// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { SectionContainer, SectionTitle } from "@eisinc/App/Widgets/DesignSystem/DesignSystem.helpers";
import { dataTable } from "@eisinc/App/Widgets/DesignSystem/DummyData/DummyData";
import logger from "@insite/client-framework/Logger";
import translate from "@insite/client-framework/Translate";
import Button from "@insite/mobius/Button";
import DataTable from "@insite/mobius/DataTable/DataTable";
import DataTableBody from "@insite/mobius/DataTable/DataTableBody";
import DataTableCell from "@insite/mobius/DataTable/DataTableCell";
import DataTableHead from "@insite/mobius/DataTable/DataTableHead";
import DataTableHeader from "@insite/mobius/DataTable/DataTableHeader";
import DataTableRow from "@insite/mobius/DataTable/DataTableRow";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Link from "@insite/mobius/Link";
import React, { FC } from "react";

interface TableTabStyles {
    titleGridItem?: GridItemProps;
    gridItem?: GridItemProps;
}

const tableTabStyles: TableTabStyles = {
    titleGridItem: {
        width: 12,
    },
    gridItem: {
        width: 12,
    },
};

const styles = tableTabStyles;
const TableTab: FC = props => {
    return (
        <SectionContainer>
            <GridItem {...styles.titleGridItem}>
                <SectionTitle>{translate("Table")}</SectionTitle>
            </GridItem>
            <GridItem width={12}>
                <DataTable>
                    <DataTableHead>
                        <DataTableHeader onSortClick={() => logger.log("sorting")} tight>
                            Date
                        </DataTableHeader>
                        <DataTableHeader onSortClick={() => logger.log("sorting")} tight title="Order Number">
                            Order #
                        </DataTableHeader>
                        <DataTableHeader tight>Ship To</DataTableHeader>
                        <DataTableHeader onSortClick={() => logger.log("sorting")} sorted="descending" tight>
                            Status
                        </DataTableHeader>
                        <DataTableHeader onSortClick={() => logger.log("sorting")} tight title="Purchase Order Number">
                            PO #
                        </DataTableHeader>
                        <DataTableHeader tight>Order Total</DataTableHeader>
                        <DataTableHeader tight title="reorder" />
                    </DataTableHead>
                    <DataTableBody>
                        {dataTable.map(({ date, order, shipTo, status, po, total }) => (
                            <DataTableRow key={order}>
                                <DataTableCell {...{ header: "Date" }}>{date}</DataTableCell>
                                <DataTableCell {...{ header: "Order #" }}>
                                    <Link href="#" {...props}>
                                        {order}
                                    </Link>
                                </DataTableCell>
                                <DataTableCell {...{ header: "Ship To" }}>{shipTo}</DataTableCell>
                                <DataTableCell {...{ header: " Status" }}>{status}</DataTableCell>
                                <DataTableCell {...{ header: "PO #" }}>{po}</DataTableCell>
                                <DataTableCell {...{ header: "Order Total" }}>${total}</DataTableCell>
                                <DataTableCell alignX="right">
                                    <Button color="primary" sizeVariant="small">
                                        Reorder
                                    </Button>
                                </DataTableCell>
                            </DataTableRow>
                        ))}
                    </DataTableBody>
                </DataTable>
            </GridItem>
        </SectionContainer>
    );
};

export default TableTab;
